import { isLoggedIn } from '../../service';

export const isShowExitHub = () => {
  return isLoggedIn();
};

export const checkIsActive = (location, paths) => {
  const cleanPath = location.pathname.split('?')[0].split('#')[0];
  return paths.some(
    (path) => cleanPath === path || cleanPath.startsWith(`${path}/`)
  );
};
